import * as CONSTRUCTOR from '../../generate';
import * as Fragments from './fragments';

export const GET_PROJECT = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'getProject',
    operationName: 'getProject',
    args: [
      { name: 'project_id', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'project_id', value: 'project_id' },
    ],
    fields: '{...ProjectTrackerResponseFields}',
    fragments: [Fragments.projectTrackerResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const GET_LEAD = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'getLead',
    operationName: 'getLead',
    args: [
      { name: 'lead_code', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'lead_code', value: 'lead_code' },
    ],
    fields: '{...LeadResponseFields}',
    fragments: [Fragments.leadResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const GET_LEAD_BY_OPPORTUNITY = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'getLeadByOpportunity',
    operationName: 'getLeadByOpp',
    args: [
      { name: 'opportunity_id', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'opportunity_id', value: 'opportunity_id' },
    ],
    fields: '{...LeadResponseFields}',
    fragments: [Fragments.leadResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const LOAN_LEAD_BY_OPPORTUNITY = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'loanLeadByOpportunity',
    args: [{ name: 'opportunity_id', type: 'String', required: true }],
    argsMap: [{ name: 'opportunity_id', value: 'opportunity_id' }],
    fields: `{
      code
      status
      name
      email
      mobile
      loanAmount
      createdAt
      updatedAt
      bankCases {
        id
        code
        status
        statusNote
        bankerID
        banker {
          id
          name
          preferredName
          email
          mobile
          mobilePrefix
          bankID
          bankBranchID
        }
        bankBranchPackage {
          id
          branchID
          name
        }
        bankID
        bank {
          id
          code
          name
        }
        identityType
        identity
        loanAmount
        referenceNo
        createdAt
        updatedAt
      }
    }`,
    fragments: [],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const LIST_LEAD_ACTIVITY_LOGS = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'listLeadActivityLogs',
    operationName: 'listLeadActivityLogs',
    args: [
      { name: 'opportunity_id', type: 'String', required: true },
      { name: 'limit', type: 'Int' },
      { name: 'offset', type: 'Int' },
      { name: 'search', type: 'String' },
    ],
    argsMap: [
      { name: 'opportunity_id', value: 'opportunity_id' },
      { name: 'limit', value: 'limit' },
      { name: 'offset', value: 'offset' },
      { name: 'search', value: 'search' },
    ],
    fields: '{...LeadActivityLogsResponseFields}',
    fragments: [Fragments.leadActivityLogsResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};
